(function() { window.GUID_64b360be_d823_41ba_8f72_13262224a04e = { getGuid: function() { return "64b360be-d823-41ba-8f72-13262224a04e"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class CachedPageVerificator extends Controls.ControlBase {
            OnDispose() {
                this.$Control.remove();
            }
            OnBindEvents() {
            }
            get ControlId() {
                return this.controlId;
            }
            get $Control() {
                return this.$control;
            }
            OnControlInstantiation(params) {
                this.controlId = params[0];
                this.$control = $('#' + params[0]); //contient le Id
                let me = this;
                if (me.$Control.length > 0) {
                    me.elementtohidewhileloading = $(me.$Control.data('elementtohidewhileloading'));
                    let tick = me.$Control.data('tick');
                    let data = {
                        tick: tick
                    };
                    CS.Ajax.Get(CS.Url.CSUrl("checkifneedrefresh"), data, function (response) {
                        if (response.refresh == true) {
                            var href = window.location.href;
                            var closingTag = "____";
                            var indexOfForceReload = href.indexOf(closingTag);
                            var indexOfEndForceReload = href.lastIndexOf(closingTag) + (closingTag).length;
                            if (indexOfForceReload > -1) {
                                var forceReloadPart = href.substr(indexOfForceReload, indexOfEndForceReload - indexOfForceReload);
                                href = href.replace(forceReloadPart, '');
                            }
                            let hrefEnd = href.length - 1;
                            let indexOfQuestMark = href.indexOf('?');
                            let indexOfAmpersand = href.indexOf('&');
                            if (indexOfQuestMark == -1) {
                                href += "?";
                            }
                            else if (indexOfQuestMark != hrefEnd && indexOfAmpersand != hrefEnd) {
                                href += "&";
                            }
                            href += closingTag + response.tick + closingTag;
                            console.info("cache.replacing url: " + window.location.href);
                            console.info("cache.replacing newurl: " + href);
                            window.location.replace(href);
                        }
                        else {
                            if (!me.elementtohidewhileloading.data('force-hidden') == true) {
                                me.elementtohidewhileloading.show();
                            }
                        }
                    });
                }
            }
        }
        Controls.CachedPageVerificator = CachedPageVerificator;
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=CachedPageVerificator.js.map
